export enum ContactTypeEnum {
    Phone,
    Email,
    Telegram,
}
